import React from 'react';
import Headshot from '../headshot_v2.jsx';

const HEAD_SIZE = 50;

const CardUser = ({ path, imageUrl, name, community, company }) => {
  return (
    <>
      <div>
        <a className='cards-user-hyperlink' href={path}>
          <div className='cards-user-container'>
            <Headshot imageUrl={imageUrl} size={HEAD_SIZE}/>
            <div className='cards-user-name-and-content-container'>
              <p className='cards-user-name'>{name}</p>
              <div className='cards-user-content-container'>
                { community && <div className='cards-user-community'>{community}</div> }
                { community && company && <div className='cards-user-community'>,&nbsp;</div> }
                { company && <div className='cards-user-company'>{company}</div>}
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default CardUser;
